import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";
import Edd from "./pages/Edd";

const App = () => (
  <AuthProvider>
    <div className="min-h-screen">
      <Edd />
    </div>
  </AuthProvider>
);

export default App;
